<script setup lang="ts">
import SiteFormPage from '@/views/apps/sites/SiteFormPage.vue'

definePage({ meta: { ...PageMeta.Sites.Add.Meta, pageTitle: PageMeta.Sites.Add.Title } })
</script>

<template>
  <SiteFormPage mode="create" />
</template>
